import React from 'react'

import { Text } from 'Components/UI'

import { EMAJIN_CORPORATE_MEMBERSHIP_PACKAGES_POINT_ITEM } from './constants'
import { Card, Container } from './styles'

function EmajinCorporateMembershipPackagesPoints() {
  return (
    <Container
      gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
    >
      {EMAJIN_CORPORATE_MEMBERSHIP_PACKAGES_POINT_ITEM.map(item => (
        <Card key={item.id}>
          {item.icon}

          <Text center medium screen24>
            {item.text}
          </Text>
        </Card>
      ))}
    </Container>
  )
}

export default EmajinCorporateMembershipPackagesPoints
